import {
  FETCH_TRAILER,
  FETCH_TRAILER_SUCCESS,
  FETCH_TRAILER_FAILURE,
} from "@utils/actionTypes";

const INIT_STATE = {
  loadingTrailer: false,
  trailersData: null
};

const trailerReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TRAILER:
      return { ...state, loadingTrailer: true };
    case FETCH_TRAILER_SUCCESS:
      return { ...state, trailersData: action.payload, loadingTrailer: false };
    case FETCH_TRAILER_FAILURE:
      return { ...state, trailersData: action.payload, loadingTrailer: false };

    default:
      return state;
  }
};
export default trailerReducer;
